export default "__VITE_PUBLIC_ASSET__08b1bd0b__"